// extracted by mini-css-extract-plugin
export default {"container":"aboutFirst_container__cMhlk","header":"aboutFirst_header__Km5vk","headerText":"aboutFirst_headerText__3QSGh","headerBullits":"aboutFirst_headerBullits__SIsG6"};